import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["id", "disabled", "required"];
import { ref, watch } from 'vue';
import moment from "moment";
import log from "../../services/Logger";
export default /*@__PURE__*/ _defineComponent({
    __name: 'FieldControlDate',
    props: {
        form: {},
        validation: {},
        field: {},
        fieldId: {},
        data: {}
    },
    emits: [
        'change',
        'focus',
        'blur'
    ],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const fieldOptions = props.field.options || {};
        const model = ref(createModel());
        const emit = __emit;
        watch(() => props.data, updateModel);
        function updateModel() {
            model.value = createModel();
        }
        function onChange() {
            const value = createValue();
            log('FieldControlDate2@change', props.field.name, value);
            emit('change', value);
        }
        function createModel() {
            if (!props.data) {
                return null;
            }
            // convert zoned date time to local date time
            const dt = moment(props.data);
            return dt.format('YYYY-MM-DD');
        }
        function createValue() {
            if (!model.value) {
                return null;
            }
            // add time zone offset if needed
            const dt = moment(model.value);
            return dt.format('YYYY-MM-DD');
        }
        function onFocus() {
            emit('focus');
        }
        function onBlur() {
            emit('blur');
        }
        return (_ctx, _cache) => {
            return _withDirectives((_openBlock(), _createElementBlock("input", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((model).value = $event)),
                onInput: onChange,
                onFocus: onFocus,
                onBlur: onBlur,
                type: "date",
                id: __props.fieldId,
                disabled: _unref(fieldOptions).disabled ?? undefined,
                required: _unref(fieldOptions).required ?? undefined,
                class: _normalizeClass(["form__control", { 'form__control--empty': !model.value }])
            }, null, 42, _hoisted_1)), [
                [_vModelText, model.value]
            ]);
        };
    }
});
